export function formatMatchStart(kickoff?: string): string | undefined {
  if (!kickoff) return undefined;

  const instant = new Date(kickoff);
  if (Number.isNaN(instant.getTime())) return undefined;

  // Format in the viewer's own locale and timezone — their browser settings
  // decide the date order, language, and 12h/24h clock.
  return instant.toLocaleString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
